"use client";
import { colors } from "gstyles";
import gs from "gstyles";
import { Link } from "components/common";
import { usePathname } from "next/navigation";
import cx from "classnames";
const ICONS = [
  {
    name: "appointment",
    icon: "calendar-inactive",
    activeIcon: "calendar-active",
    title: "Lịch hẹn",
    href: "/",
  },
  {
    name: "manage",
    icon: "chart-inactive",
    activeIcon: "chart-active",
    title: "Quản lý",
    href: "/manage",
  },
  {
    name: "promotion",
    icon: "ticket-discount-inactive",
    activeIcon: "ticket-discount-active",
    title: "Ưu đãi",
    href: "/promotion",
  },

  {
    name: "notification",
    icon: "notification-inactive",
    activeIcon: "notification-active",
    title: "Thông báo",
    href: "/notification",
  },
  {
    name: "account",
    icon: "profile-inactive",
    activeIcon: "profile-active",
    title: "Tài Khoản",
    href: "/account",
  },
];
export default function BottomTab() {
  const pathname = usePathname();
  return (
    <div className="flex justify-between items-center w-full border-t border-gray-200">
      {ICONS.map((icon) => {
        const isActive = icon.href === pathname;
        return (
        <Link href={icon.href} key={icon.title}>
          <div
            className="flex flex-col items-center justify-center h-16 w-[4.6875rem] select-none"
          >
            <div key={icon.title} className="mb-1 relative w-6 h-6">
              {gs.icons({
                className: cx(
                  "absolute top-0 left-0 transition-opacity duration-300",
                  isActive ? "opacity-0" : "opacity-100"
                ),
                name: icon.icon,
                size: 24,
              })}
              {gs.icons({
                className: cx(
                  "absolute top-0 left-0 transition-opacity duration-300",
                  isActive ? "opacity-100" : "opacity-0"
                ),
                name: icon.activeIcon,
                size: 24,
              })}
            </div>
            <div className={cx(
              "text-xs transition-colors duration-300",
              isActive ? "text-primary" : "text-gray-500"
            )}>{icon.title}</div>
          </div>
        </Link>
      );})}
    </div>
  );
}
